import React, { useEffect, useState } from 'react';
import {
  Box, Card, CardContent, TextField, Typography,
  CircularProgress, Alert,
} from '@mui/material';
import LockResetIcon from '@mui/icons-material/LockReset';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../reduxStore/Store';
import { forgotPassword, clearAuthError } from '../reduxStore/AuthSlice';

const ForgotPasswordPage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { loading, error } = useSelector((state: RootState) => state.AuthSlice);

  const [login,      setLogin]      = useState('');
  const [email,      setEmail]      = useState('');
  const [sent,       setSent]       = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [localErr,   setLocalErr]   = useState('');

  useEffect(() => {
    if (error) dispatch(clearAuthError());
    setLocalErr('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [login, email]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!login.trim() || !email.trim()) {
      setLocalErr('Identifiant et email requis.');
      return;
    }
    setSubmitting(true);
    const result = await dispatch(forgotPassword({ login: login.trim(), email: email.trim() }));
    if (forgotPassword.fulfilled.match(result)) {
      setSent(true);
    } else {
      setSubmitting(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f5f5f5' }}>
      <Card sx={{ width: 420, boxShadow: 4, borderRadius: 3 }}>
        <CardContent sx={{ p: 4 }}>

          <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
            <Box sx={{ width: 52, height: 52, borderRadius: '14px', bgcolor: 'warning.main', display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1.5 }}>
              <LockResetIcon sx={{ color: '#fff', fontSize: 28 }} />
            </Box>
            <Typography variant="h6" fontWeight={700}>Mot de passe oublié</Typography>
            <Typography variant="caption" color="text.secondary">Gsoft Web ERP</Typography>
          </Box>

          {sent ? (
            <Alert severity="success" icon={<CheckCircleOutlineIcon />}>
              Un email de réinitialisation a été envoyé. Vérifiez votre boîte mail et cliquez sur le lien.
            </Alert>
          ) : (
            <>
              {(localErr || error) && (
                <Alert severity="error" sx={{ mb: 2 }}>{localErr || error}</Alert>
              )}
              <form onSubmit={handleSubmit}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Entrez votre identifiant et votre email pour recevoir un lien de réinitialisation.
                </Typography>
                <TextField
                  label="Identifiant" value={login}
                  onChange={(e) => setLogin(e.target.value)}
                  fullWidth size="small" sx={{ mb: 2 }} autoFocus
                />
                <TextField
                  label="Email" type="email" value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  fullWidth size="small" sx={{ mb: 2 }}
                />
                <Button variant="contained" type="submit" fullWidth disabled={submitting || loading || !login.trim() || !email.trim()}>
                  {loading ? <CircularProgress size={20} color="inherit" /> : 'Envoyer le lien'}
                </Button>
              </form>
            </>
          )}

          <Box textAlign="center" mt={2}>
            <Typography variant="caption" color="text.secondary">
              <Link to="/login" style={{ color: 'inherit', fontWeight: 600 }}>Retour à la connexion</Link>
            </Typography>
          </Box>

        </CardContent>
      </Card>
    </Box>
  );
};

export default ForgotPasswordPage;
